import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../../utils/axiosInstance";
import { useAuth } from '../../hooks/useAuth';
import { NavLink, useNavigate } from "react-router-dom";
import "./Header.css";
import { FaCaretDown, FaCaretUp, FaBars, FaRegWindowClose } from "react-icons/fa";
import { GiOilySpiral } from "react-icons/gi";

const Header = () => {
  const { isAuthenticated, setIsAuthenticated } = useAuth();
  const [showNav, setShowNav] = useState(false);
  const [showOfferingsDropDown, setShowOfferingsDropDown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const headerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setShowOfferingsDropDown(false);
        setShowNav(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isAuthenticated]);

  const handleLogout = async () => {
    try {
      localStorage.removeItem('token');
      setIsAuthenticated(false);
      navigate('/Login'); // Redirect to login after logout
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const toggleNav = () => {
    setIsLoading(true); 
    if (showNav) {
      setShowOfferingsDropDown(false);
    }
  
    setTimeout(() => {
      setIsLoading(false); 
    }, 400);
    setShowNav(!showNav);
  };
  
  const handleProfileClick = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      // Redirect to login if the user is not authenticated
      navigate('/Login');
      return;
    }

    try {
      // Check token validity when clicking on profile
      const response = await axiosInstance.get('/validateToken', {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.status === 200 && response.data.valid) {
        navigate('/Profile');
      } else {
        localStorage.removeItem('token');
        setIsAuthenticated(false);
        navigate('/Login');  // Redirect to login if token is invalid
      }
    } catch (err) {
      localStorage.removeItem('token');
      setIsAuthenticated(false);
      navigate('/Login');  // Redirect to login if token check fails
    }
  };

  return (
    <nav className="navbar-dogbar">
      <div className="container-fluid" ref={headerRef}>
        <NavLink className="navbar-brand" to="/">
          <img src="/Logo2Cropped.png" alt="DogBar Logo" />
        </NavLink>
        <div className="hamburger-icon" onClick={toggleNav}>
          {isLoading ? <GiOilySpiral className="loading-icon" /> : (showNav ? <FaRegWindowClose /> : <FaBars />)}
        </div>
        <ul className={`navbar-nav ms-auto ${showNav ? 'show' : ''}`}>
          <li className="nav-item">
            <NavLink className="nav-link" to="/Dog-Park" onClick={() => setShowNav(false)}>Dog Park</NavLink>
          </li>
          <li className="nav-item offering-dropdown-container">
            <span className="nav-link offering-dropdown-toggle" onClick={() => setShowOfferingsDropDown(!showOfferingsDropDown)}>
            What We Got {showOfferingsDropDown ? <FaCaretUp /> : <FaCaretDown />}
            </span>
            <div className={`offerings-dropdown ${showOfferingsDropDown ? 'show' : ''}`}>
              {/* Coming Soon Mode: Dog Day Passes link temporarily hidden until pricing is ready */}
              {/* TODO: Uncomment when business opens and pricing is ready to be displayed */}
              {/* <NavLink className="offerings-dropdown-item" to="/Dog-Passes" onClick={() => { setShowNav(false); setShowOfferingsDropDown(false); }}>Dog Day Passes</NavLink> */}
              <NavLink className="offerings-dropdown-item" to="/Bar" onClick={() => { setShowNav(false); setShowOfferingsDropDown(false); }}>Bar Menu</NavLink>
              <NavLink className="offerings-dropdown-item" to="/Food" onClick={() => { setShowNav(false); setShowOfferingsDropDown(false); }}>Food Truck Menu</NavLink>
              <NavLink className="offerings-dropdown-item" to="/Merchandise" onClick={() => { setShowNav(false); setShowOfferingsDropDown(false); }}>Merchandise & Apparel</NavLink>
            </div>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/Events" onClick={() => setShowNav(false)}>Upcoming Events</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/About-Us" onClick={() => setShowNav(false)}>About Us</NavLink>
          </li>
          {!isAuthenticated ? (
            <>
              <li className="nav-item">
                <NavLink className="nav-link" to="/New-Account" onClick={() => setShowNav(false)}>New Account</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/Login" onClick={() => setShowNav(false)}>Login</NavLink>
              </li>
            </>
          ) : (
            <>
              <li className="nav-item">
                <NavLink className="nav-link" to="/Profile" onClick={handleProfileClick}>Profile</NavLink>
              </li>
              <li className="nav-item">
                {/* Use preventDefault so logout stays on Login page; href="/" was causing redirect to Landing after navigate('/Login') */}
                <a className="nav-link" href="/Login" onClick={(e) => { e.preventDefault(); handleLogout(); setShowNav(false); }}>Logout</a>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Header;
